import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { ReactNode } from 'react';

import { Typography } from '@/components/Typography';
import { cn } from '@/utils/cn';

interface ErrorFallbackProps {
  icon?: IconDefinition;
  title: ReactNode;
  description?: ReactNode;
  details?: ReactNode;
  actions?: ReactNode;
  className?: string;
}

/** Carte d'erreur centrée : icône, titre, description, détails et actions. */
export const ErrorFallback = ({
  icon = faTriangleExclamation,
  title,
  description,
  details,
  actions,
  className,
}: ErrorFallbackProps) => (
  <div
    className={cn(
      'flex w-full flex-col items-center gap-4 rounded-xl border bg-card p-10 text-center',
      className,
    )}
  >
    <div className="flex size-12 items-center justify-center rounded-full bg-destructive/10 text-destructive">
      <FontAwesomeIcon icon={icon} className="size-5" />
    </div>
    {typeof title === 'string' ? (
      <Typography variant="h4">{title}</Typography>
    ) : (
      title
    )}
    {description && (
      <Typography variant="paragraphSmall" className="max-w-xl break-words">
        {description}
      </Typography>
    )}
    {details && <div className="w-full">{details}</div>}
    {actions && (
      <div className="flex flex-wrap items-center justify-center gap-2">
        {actions}
      </div>
    )}
  </div>
);
